import { FormControl, TextField  } from '@material-ui/core';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import React from 'react';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      "& .MuiInputBase-input": {
        '-webkit-box-shadow': '0 0 0 50px white inset'
      },
      "& .MuiInputBase-root": {
        height: '48px',
        fontSize: "1.4rem",
        innerHeight: 'inherit',
        [theme.breakpoints.up('xl')]: {
          fontSize: "1.6rem",
          height: '48px',
        },
      },
      "& .MuiInputLabel-root": {
        fontSize: "1.4rem",
        [theme.breakpoints.up('xl')]: {
          fontSize: "1.6rem",
        },
      },
      "& .MuiOutlinedInput-input": {
        padding: '16px 14px'
      },
      "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
        fontSize: "1.4rem",
        [theme.breakpoints.up('xl')]: {
          fontSize: "1.6rem",
        },
      },
      "& .MuiFormHelperText-root": {
        fontSize: "1.2rem",
        [theme.breakpoints.up('xl')]: {
          fontSize: "1.4rem",
        },
      }
    }
}));

type SelectFieldTypes = {
  value?: string | number,
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void,
  onBlur?: () => void,
  variant?: 'outlined' | 'filled' | 'standard',
  id?: string,
  error?: any,
  helperText?: string | false | undefined,
  name: string,
  fullWidth?: boolean,
  required?: boolean,
  type?: string | undefined,
  InputProps: any
}

// interface InputProps extends InputHTMLAttributes<HTMLInputElement> {

// }

export const InputSearch = ({
  value, onChange, onBlur, variant,
  id, error, helperText,
  name, fullWidth = false, required = false,
  type = 'text', InputProps  }: SelectFieldTypes) => {
  const classes = useStyles();

  return (
    <FormControl variant='outlined' fullWidth={fullWidth}>
      <TextField
        placeholder="Buscar"
        type={type}
        className={classes.root}
        id={id}
        name={name}
        value={value}
        error={error}
        helperText={helperText}
        onChange={onChange}
        onBlur={onBlur}
        variant="outlined"
        required={required}
        InputProps={InputProps}
       />
    </FormControl>
  )
}